import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import {cl,globs} from '../../components/utils/utils';

class C18MuiFormControl extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.state={
    }
  }
  
  render(){
    if(globs.noMui){
      return(
        <div>
          {this.props.children}
        </div>
      )
    }else{
      return React.createElement(FormControl,this.props)
    }
//     return React.createElement(FormControl,this.props)
  }
}
      
export default C18MuiFormControl;
 
